import { toDigitsOnly } from '@sravni/creditselection-customer-utils/lib/utils/customers';

import { capitalizeFirstLetter } from 'shared/lib';
import type { TLoansCalculationCustomerData } from 'shared/types/TLoansService';

import type { TCreditFormCommonFields } from 'entities/creditForm';
import { Birth } from 'entities/creditForm/lib/formatters/base';

export class Passport {
  constructor(
    private readonly passport: Pick<
      Partial<TCreditFormCommonFields>,
      | 'passportIssueDate'
      | 'passportIssuedBy'
      | 'passportNumber'
      | 'unitCode'
      | 'fullName'
      | 'gender'
      | 'birthPlace'
      | 'birthDate'
    >,
    // eslint-disable-next-line no-empty-function
  ) {}

  private parseNumber() {
    const normalizedPassport = toDigitsOnly(this.passport.passportNumber || '');

    const serial = normalizedPassport?.slice(0, 4);
    const number = normalizedPassport?.slice(4);

    return [serial, number].join(' ').trim();
  }

  profile() {
    const birth = new Birth(this.passport).map();

    return {
      ...birth,
      fullName: this.passport.fullName?.value || null,
      gender: this.passport.gender,
      passportNumber: this.parseNumber(),
      passportIssueDate: this.passport.passportIssueDate,
      passportIssuedBy: this.passport.passportIssuedBy,
      unitCode: this.passport.unitCode,
    };
  }

  loans() {
    const { gender, passportIssueDate, passportIssuedBy, unitCode, ...rest } = this.profile();

    return {
      ...this.profile(),
      gender: capitalizeFirstLetter(gender || 'Unknown') as TLoansCalculationCustomerData['gender'],
      passportIssueDate: passportIssueDate || '',
      passportIssuedBy: passportIssuedBy || '',
      unitCode: unitCode || '',
      ...rest,
    };
  }
}
